import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AreYouSureDialogComponent } from '../dialogs/are-you-sure-dialog/are-you-sure-dialog.component';

export interface CanComponentDeactivate {
  canDeactivate(): boolean | Observable<boolean>;
  hasUnsavedChanges(): boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  constructor(private dialog: MatDialog) {}

  canDeactivate(component: CanComponentDeactivate): Observable<boolean> | boolean {
    // If there are no unsaved changes, allow navigation
    if (!component.hasUnsavedChanges()) {
      return true;
    }

    // Show confirmation dialog for unsaved changes
    return this.dialog.open(AreYouSureDialogComponent, {
      data: {
        areYouSureInfo: {
          title: 'Unsaved Changes',
          description: 'You have unsaved changes that will be lost if you continue.',
          warning: 'Are you sure you want to leave without saving?',
          continueBtn: {
            color: 'warn',
            text: 'Leave Without Saving'
          },
          cancelBtn: {
            color: 'primary',
            text: 'Stay and Save'
          }
        }
      }
    }).afterClosed().pipe(
      map(result => !!result) // Convert undefined/null to false
    );
  }
} 